module.exports = __webpack_public_path__ + "img/LOGO DOWNLOAD-02.c7467c29.png";